<template>
    <el-cascader
        @change="handleModel"
		:change-on-select="elVersion === '2.8.2'"
        :disabled="disabled"
        :class="classname"
        filterable
        :options="options"
        :placeholder="$t('LnkValuelistCascader.placeholder')"
        v-model="productArray"
    ></el-cascader>
</template>

<script>
    /** @name: 值列表 三级 级联组件
     * @createdby:MengJie
     * @modifier:Wangyue
     * @props:
     * prop-mapping: Array （属性映射，必选）绑定对象的属性名[（一级），（二级），（三级）]
     * val-types: Array 级联的值列表，需按一级，二级，三级顺序
     * v-model: String 数据绑定的 vue 变量
     * classname: String 设置元素的class名称,可以动态绑定
    *
    * @hooks:
    *
    * @example:
    * html:
    *     <lnk-valuelist-cascader
        *     :prop-mapping="['prodMatSeries','prodSecSeries','prodThirdSeries']"
        *     :val-types="['PROD_MAT_SERIES','PRODUCT_TOP_CATEGORY','PRODUCT_SEC_CATEGORY']"
        *     v-model="product"
        *     classname="innerbox">
        *     </lnk-valuelist-cascader>
    * js:
    *     ……
    *      data:{
    *          product:{},//组件会在原有对象的基础上添加或更新属性值
    *          disable:false,//组件的禁用状态
    *                 ……
    *      }
    *      ……
    */


    export default {
        name: "lnk-valuelist-cascader",
        data() {
            return {
                options: [], // 级联数组
                productArray: []
            };
        },
        model: {
            prop: 'product',
            event: 'change'
        },
        props: {
            propMapping: {
                type: Array,
                default(){
                    return [0, 1, 2];
                }
            },
            valTypes: Array,
            classname: String,
            product: Object,
            disabled: Boolean,
            endVal: String,
            endType: String,
            levels:{
                type:Number,
                default(){
                    return 3;
                }
            }
        },
        watch: {
            product(val) {
                if(val!=undefined) this.setProduct(val);
                else this.productArray=[];
            },
            endVal(val){
                this.getProdFromEndVal();
            }
        },
        methods: {
            Post(url, fdata, handleSuccess, handleErr) { // post请求方法
                if (handleErr == undefined) handleErr = this.defaultErrHandler;
                this.$http.post(url, fdata, true)
					.then(handleSuccess)
					.catch(handleErr);
            },
            defaultErrHandler(err) {
                console.log(err);
            },

            /*
            * 方法：初始化方法
            * 依赖：
            *  valTypes[]
            *
            * */
            async initProductList() {
                var that = this;
              	await this.$lov.getLovByType(that.valTypes.join(','));// 获取所有并缓存
                var tmp1 = await this.$lov.getLovByType(this.valTypes[0]);// 获取一级
                // linkLov.getLovByType(that.valTypes[1]);// 获取二级
                // linkLov.getLovByType(that.valTypes[2]);// 获取三级
                for(var i = 0; i<tmp1.length;){
                    var add1 = {};
                    add1.label = tmp1[i].name;
                    add1.value = tmp1[i].val;

                    var tmp2 = await this.$lov.getLovByParentTypeAndValue(that.valTypes[1], that.valTypes[0], tmp1[i].val);
                    if(tmp2.length!=0){
                        add1.children = [];
                    }
                    for(var j = 0; j<tmp2.length;){
                        var add2 = {};
                        add2.label = tmp2[j].name;
                        add2.value = tmp2[j].val;
                        var tmp3 = await this.$lov.getLovByParentTypeAndValue(that.valTypes[2], that.valTypes[1], tmp2[j].val);
                        if(tmp3.length!=0){
                            add2.children = [];
                        }
                        for(var k = 0; k<tmp3.length;){
                            var add3 = {};
                            add3.label = tmp3[k].name;
                            add3.value = tmp3[k].val;
                            Vue.set(add2.children, k++, add3);
                        }
                        Vue.set(add1.children, j++, add2);
                    }
                    Vue.set(that.options, i++, add1);
                }
            },
            getProdFromEndVal(){
                const eVal=this.endVal;
                const eType=this.endType;
                if(eVal==undefined || eType==undefined) {
                    if(this.product==undefined) this.productArray = [];
                    return;
                }

                var len=-1;
                for(var i=0; i<this.valTypes.length; i++){
                    if(this.valTypes[i]==eType){
                        len=i;
                        break;
                    }
                }
                if(len==-1) return;
                const opts=this.options;
                for(var i in opts){
                    if(len==0){
                        if(opts[i].value==eVal){
                            this.productArray=[eVal];
                        }
                    }else{
                        for(var j in opts[i].children){
                            if(len==1){
                                if(opts[i].children[j].value==eVal){
                                    this.productArray=[opts[i].value, eVal];
                                }
                            }else{
                                for(var k in opts[i].children[j].children){
                                    if(opts[i].children[j].children[k].value==eVal){
                                        this.productArray=[opts[i].value, opts[i].children[j].value, eVal];
                                    }
                                }
                            }
                        }
                    }
                }

            },


            handleModel(val) {
                if(this.propMapping==undefined){
                    var arr=linkTools.deepCopy(val);
                    this.$emit('change', arr);
                    this.$emit('update:endVal', arr[arr.length-1]);
                    this.$emit('update:endType', this.valTypes[arr.length-1]);
                }else{
                    var obj = linkTools.deepCopy(this.product) || {};

                    const map=this.propMapping;
                    var tmp={};
                    for(var i=0; i<this.levels; i++){
                        tmp[map[i]]=val[i] || '';
                    }
                    linkTools.coverPropsByTpl(obj, tmp);
                    this.$emit('change', obj);
                }
            },
            setProduct(val) {
                if(val==undefined) return;
                var arr = [];
                const map=this.propMapping;
                for (var i = 0; i < this.levels; i++) {
                    var tmp = val[map[i]];
                    if (!tmp) break;
                    arr[i] = tmp;
                }
                this.productArray = arr;
            }

        },
        created() {
            this.initProductList();
            this.setProduct(this.product);
            this.getProdFromEndVal();
        }
    }
</script>

<style scoped>

</style>
